import styled from "styled-components";

const IconWrapper = styled.svg`
  width: 48px;
  height: 48px;
`;

export const BabyYoda = () => (
  <IconWrapper aria-hidden="true">
    <path
      fill="#aed581"
      d="M37.054,28.813l-3.193,2c0,0,1.064,3,3.193,2S37.054,28.813,37.054,28.813z"
    ></path>
    <path
      fill="#ffcc80"
      d="M38,28l-7,2V19c0,0,0.526-0.158,1,0C35,20,38,28,38,28z"
    ></path>
    <path
      fill="#ffcc80"
      d="M10,28l7,2V19c0,0-0.526-0.158-1,0C13,20,10,28,10,28z"
    ></path>
    <path
      fill="#ffb74d"
      d="M38.155,29.866l-4.926,1.845c-0.574,0.215-1.213-0.076-1.428-0.65l-0.625-1.668 c-0.215-0.574,0.076-1.213,0.65-1.428l4.926-1.845c0.574-0.215,1.213,0.076,1.428,0.65l0.625,1.668 C39.019,29.012,38.728,29.651,38.155,29.866z"
    ></path>
    <path
      fill="#aed581"
      d="M10.946,28.813l3.193,2c0,0-1.064,3-3.193,2S10.946,28.813,10.946,28.813z"
    ></path>
    <path
      fill="#ffb74d"
      d="M9.845,29.866l4.926,1.845c0.574,0.215,1.213-0.076,1.428-0.65l0.625-1.668 c0.215-0.574-0.076-1.213-0.65-1.428l-4.926-1.845c-0.574-0.215-1.213,0.076-1.428,0.65l-0.625,1.668 C8.981,29.012,9.272,29.651,9.845,29.866z"
    ></path>
    <path
      fill="#ffcc80"
      d="M35.788,39.375c0.126,0.965-0.456,1.885-1.387,2.168C32.457,42.135,27.945,43,24,43 s-8.457-0.865-10.401-1.457c-0.931-0.284-1.513-1.203-1.387-2.168L17,18h14L35.788,39.375z"
    ></path>
    <path
      fill="#ff8a65"
      d="M33,9c-1.37,0-2.887,0.274-3.5,1.5v4C34,15,42,9,42,9H33z"
    ></path>
    <path
      fill="#aed581"
      d="M30.03,15.528c-0.219,0-0.433-0.011-0.641-0.034l0.221-1.987c2.41,0.264,6.323-1.75,9.135-3.506H33 c-1.414,0-2.291,0.319-2.605,0.947l-1.789-0.895C29.287,8.69,30.766,8,33,8h9c0.431,0,0.813,0.275,0.948,0.684 C43.085,9.092,42.944,9.542,42.6,9.8C42.275,10.044,34.904,15.528,30.03,15.528z"
    ></path>
    <path
      fill="#ff8a65"
      d="M15,9H6c0,0,8,6,12.5,5.5v-4C17.887,9.274,16.37,9,15,9z"
    ></path>
    <path
      fill="#aed581"
      d="M17.97,15.528c-4.874,0-12.245-5.484-12.569-5.728C5.056,9.542,4.915,9.092,5.052,8.684 C5.188,8.275,5.569,8,6,8h9c2.234,0,3.713,0.69,4.395,2.053l-1.789,0.895C17.291,10.319,16.414,10,15,10H9.255 c2.812,1.756,6.733,3.772,9.135,3.506l0.221,1.987C18.402,15.517,18.188,15.528,17.97,15.528z"
    ></path>
    <path
      fill="#aed581"
      d="M24,6c-5.01,0-8,2.332-8,6.238c0,3.5,2.552,5.762,6.5,5.762h3c3.948,0,6.5-2.262,6.5-5.762 C32,8.332,29.01,6,24,6z"
    ></path>
    <path fill="#7cb342" d="M25,16c0,0.552-0.448,1-1,1s-1-0.448-1-1H25z"></path>
    <path
      fill="#7cb342"
      d="M24,12.076l-0.248-0.142c-3.192-1.825-5.946-0.036-5.975-0.018l-0.555-0.832 c0.13-0.086,3.158-2.055,6.777-0.154c3.615-1.901,6.647,0.068,6.777,0.154l-0.554,0.833c-0.113-0.075-2.8-1.798-5.976,0.017 L24,12.076z"
    ></path>
    <path
      fill="#ffb74d"
      d="M26,19v23.93C25.32,42.98,24.65,43,24,43s-1.32-0.02-2-0.07V19H26z"
    ></path>
    <path
      fill="#ffb74d"
      d="M31.778,15c-1.722,0.642-2.222,3-7.778,3s-6.056-2.358-7.778-3C14.579,14.387,14,18,14,20 c0,2.828,10,3,10,3s10-0.172,10-3C34,18,33.421,14.387,31.778,15z"
    ></path>
    <path fill="#3e2723" d="M23,15c0-3-4-3-5-1C18,15,21,17,23,15z"></path>
    <path fill="#3e2723" d="M25,15c0-3,4-3,5-1C30,15,27,17,25,15z"></path>
    <path
      fill="#ffa726"
      d="M27.13,21.96c-0.24,0.33-0.51,0.64-0.81,0.92h-0.01C24.97,22.98,24,23,24,23s-1.02-0.02-2.4-0.13 c1.75-0.25,3.11-0.97,3.9-2.08c0.62-0.86,0.87-1.93,0.68-2.94c0.78-0.11,1.41-0.28,1.94-0.49C28.45,18.95,28.09,20.62,27.13,21.96z"
    ></path>
    <path d="M22,13.5c0,0.83-0.67,1.5-1.5,1.5S19,14.33,19,13.5c0-0.2,0.04-0.39,0.11-0.56c0.86-0.43,1.96-0.46,2.78,0 C21.96,13.11,22,13.3,22,13.5z"></path>
    <circle cx="19.5" cy="13.5" r=".5" fill="#d7ccc8"></circle>
    <path d="M29,13.5c0,0.83-0.67,1.5-1.5,1.5S26,14.33,26,13.5c0-0.2,0.04-0.39,0.11-0.56c0.82-0.46,1.92-0.43,2.78,0 C28.96,13.11,29,13.3,29,13.5z"></path>
    <circle cx="26.5" cy="13.5" r=".5" fill="#d7ccc8"></circle>
  </IconWrapper>
);
